type ActivationSuccessViewProps = {
  title: string
  body: string
  goToLoginLabel: string
  goHomeLabel: string
  loginHref: string
  homeHref: string
}

export const ActivationSuccessView = ({
  title,
  body,
  goToLoginLabel,
  goHomeLabel,
  loginHref,
  homeHref,
}: ActivationSuccessViewProps) => (
  <div className="space-y-5">
    <div className="space-y-2">
      <h2 className="text-2xl font-semibold tracking-tight text-(--color-text-primary)">{title}</h2>
      <p className="text-sm leading-relaxed text-(--color-text-secondary)">{body}</p>
    </div>
    <div className="grid gap-2.5 sm:grid-cols-2">
      <a href={loginHref} className="ca-btn-primary inline-flex h-11 items-center justify-center px-4 text-sm font-semibold">
        {goToLoginLabel}
      </a>
      <a
        href={homeHref}
        className="ca-btn-secondary inline-flex h-11 items-center justify-center rounded-lg border border-(--color-border-default) px-4 text-sm font-semibold text-(--color-text-secondary)"
      >
        {goHomeLabel}
      </a>
    </div>
  </div>
)
